<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\surveyManual-1.png" alt="" /></div>
                <div>
                    <p>① Sau khi nộp [Bản cam kết] thì % tiến độ sẽ tăng lên, nhấn vào nút [Bảng khảo sát] ở trên thanh menu con, thì màn hình bảng khảo sát sẽ được hiển thị.</p>
                </div>
                <div><img src="/static\images\vi\newManual\surveyManual-2.png" alt="" /></div>
                <div>
                    <p>② Trả lời tất cả các câu hỏi trên màn hình bảng khảo sát.</p>
                    <p>③ Nhấn nút [Gửi đi] để nộp Bảng khảo sát.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/survey_manual.vue